const tabs = [
  "Themes",
  "Categories",
  "Genres",
  "Languages",
  "Onboarding",
  "Maturity Ratings",
];
const subTabs = ["Posters", "Avatars", "Questions"];
const priorityList = ["NONE", "PRIMARY", "SECONDARY", "UPCOMING"];
const columns = {
  Posters: ["Title", "Languages", "Categories", "Genres", "Enable", "Action"],
  Avatars: ["Title", "Gender", "User Group", "Peer group", "Enable", "Action"],
  Questions: [
    "Title",
    "Subheading",
    "Type",
    "Include Icons",
    "Enable",
    "Action",
  ],
};
const questionType = [
  {
    
    name:"Single-select",
    value:"single"
  },{
    name:"Multi-select",
    value:"multi"

  }
]

const Sizes = {
  Theme: {
    icon: {
      mobile: "",
      tv: "",
      tablet: "",
      web: "",
    },
    poster: {
      mobile: "[3:1]",
      tv: "[3:1]",
      tablet: "[3:1]",
      web: "[3:1]",
    },
  },
  Category: {
    icon: {
      mobile: "[1:1]",
      tv: "[1:1]",
      tablet: "[1:1]",
      web: "[1:1]",
    },
    poster: {
      mobile: "[3:2]",
      tv: "[3:2]",
      tablet: "[3:2]",
      web: "[3:2]",
    },
  },
  Genre: {
    icon: {
      mobile: "[1:1]",
      tv: "[1:1]",
      tablet: "[1:1]",
      web: "[1:1]",
    },
    poster: {
      mobile: "[3:2]",
      tv: "[3:2]",
      tablet: "[3:2]",
      web: "[3:2]",
    },
  },
  Languages: {
    icon: {
      mobile: "[3:1]",
      tv: "[3:1]",
      tablet: "[3:1]",
      web: "[3:1]",
    },
    poster: {
      mobile: "[3:1]",
      tv: "[3:1]",
      tablet: "[3:1]",
      web: "[3:1]",
    },
  },
};

const allIcons = {
  TV: {
    icon: {
      enabled: { file: null, size: null, type: null, icon_type: null },
      disabled: { file: null, size: null, type: null, icon_type: null },
    },
    poster: { file: null, size: null, type: null, icon_type: null },
  },
  Web: {
    icon: {
      enabled: { file: null, size: null, type: null, icon_type: null },
      disabled: { file: null, size: null, type: null, icon_type: null },
    },
    poster: { file: null, size: null, type: null, icon_type: null },
  },
  Mobile: {
    icon: {
      enabled: { file: null, size: null, type: null, icon_type: null },
      disabled: { file: null, size: null, type: null, icon_type: null },
    },
    poster: { file: null, size: null, type: null, icon_type: null },
  },
  Tablet: {
    icon: {
      enabled: { file: null, size: null, type: null, icon_type: null },
      disabled: { file: null, size: null, type: null, icon_type: null },
    },
    poster: { file: null, size: null, type: null, icon_type: null },
  },
};

export { Sizes, allIcons, tabs, subTabs, priorityList, columns, questionType };
